import state from './state.file'
import mutations from './mutations.file'
import actions from './actions.file'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}